const matchFFLLicense = /^(\d)-?(\d\d)(?:-?[\dxX]{3}-?[\dxX]{2}-?[\da-zA-Z]{2})?-?(\d\d\d\d\d)$/;
const matchFFLFullLicense = /^(\d)-?(\d\d)-?[\d]{3}-?[\d]{2}-?[\d]{1}[a-zA-Z]{1}-?(\d\d\d\d\d)$/;

abstract class Recognizer {
  patterns: RegExp[] = [];
  match?: string[] = undefined;

  matches(val: string): any {
    for (const re of this.patterns) {
      const matches = val.match(re);
      if (matches) {
        this.match = matches;
        return this.match;
      }
    }
  }
}

export default class FFLRecognizer extends Recognizer {
  patterns = [matchFFLFullLicense, matchFFLLicense];
}
